import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDurationChange]',
  standalone: true,
})
export class DurationChangeDirective {
  private control = inject(NgControl);

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove all non-numeric characters
    value = value.replace(/[^0-9]/g, '');

    // Update the form control but do not enforce the minimum value yet
    this.control.control?.setValue(value);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Enforce the minimum value of 2 on blur
    if (value) {
      const numericValue = parseInt(value, 10);
      if (numericValue < 2) {
        value = '2';
      }
    }

    // Update the input and the form control
    input.value = value;
    this.control.control?.setValue(value);
  }
}
